import {deepClone, findBy} from "@/lib/utils";

import Queue from "./queue";

const budgets = [{"id": 1, "name": "Предварительный бюджет"}, {"id": 2, "name": "Предпосевной бюджет"}]

function initialState() {
  return {
    dict: {},
    applicationtypes: [],
    availabilityinstock: [],
    defectiveactstatuses: [],
    causeofdefect: [],
    unitofmeasurementtype: [],
    sparepartsaccountingtype: [],
    sparepartgroups: [],
    alertmethods: [],
    alertrules: [],
    alerts: [],
    alerttype: [],
    agrofontypes: [],
    agronomists: [],
    analysiscardtypes: [],
    apimethods: {},
    areaassignments: [],
    singleareaassignments: [],
    assignmentsdailyreportitems: [],
    assignmenttypes: [],
    barrierdeviationreportitemtypes: [],
    brigades: [],
    businessprocesses: [],
    caravailabilities: [],
    carfuelsettingothersensortypes: [],
    cargpsidentifier: [],
    carmarks: [],
    carmodelfuelnorms: [],
    carmodelgroups: [],
    carmodels: [],
    cars: [],
    carschild: [],
    carsall: [],
    carsensors: [],
    carsensorsall: [],
    carstatusextended: {},
    carstopstatuses: [],
    carstops: [],
    carlocations: [],
    cartypes: [],
    chemicalpreparationprices: [],
    chemicalpreparations: [],
    chemicalpreparationtypes: [],
    chemistrylimitfact: [],
    chemistrylimits: [],
    clearingactreportitems: [],
    caravailability: [],
    compositions: [],
    conditiontypes: [],
    contractors: [],
    cropbalanceusers: [],
    cropdecommission: [],
    cropevaluations: [],
    croprotations: [],
    croprotationsproduction: [],
    cropevaluationsievestype: [],
    cropevaluationcloggingdegreetype: [],
    cropevaluationparametertype: [],
    cropevaluationsowingdatestype: [],
    culturedepths: [],
    culturefieldzones: [],
    cultureparameters: [],
    culturequalityconditions: [],
    culturequalitytypes: [],
    culturerotation: [],
    cultures: [],
    culturetypes: [],
    customorganizations: [],
    customorganizationsplan: [],
    destinationwarehouses: [],
    destructionacts: [],
    developers: [],
    diseases: [],
    diseaselevels: [],
    dozhimreservations: [],
    downtimereasons: [],
    echelons: [],
    echelonTypes: [],
    echelonharvestings: [],
    employees: [],
    employeesall: [],
    employeestatus: [],
    equipments: [],
    eventtype: [],
    faqcategories: [],
    faqpages: [],
    fertilizerlimits: [],
    fieldcondition: [],
    fieldcontours: [],
    fieldlastassignments: [],
    fieldlastassignmentsall: [],
    fieldsall: [],
    fieldtypes: [],
    fieldweediness: [],
    fieldzones: [],
    fieldscores: [],
    fieldscoresall: [],
    fieldsurveys: [],
    finalproducts: [],
    finalproducttranslations: [],
    finalproducttypes: [],
    fuelnorms: [],
    fueldeviationsrequeststatus: [],
    fueltypes: [],
    globaladmin: [],
    gpsproviders: [],
    grainindicator: [],
    grainoutsideofwarehouse: [],
    grainprocessings: [],
    grainprocessingtypes: [],
    grainwastes: [],
    growthdefinitions: [],
    helpstructureitems: [],
    incomingtransfers: [],
    insects: [],
    instruments: [],
    others: [],
    instrumenttypes: [],
    internaltransfers: [],
    inventoriesreporttypes: [],
    inventory: [],
    kadastrfield: [],
    kadastrfieldgroup: [],
    kml: [],
    kmlspec: [],
    kmlchild: [],
    kmlall: [],
    kmlcontractor: [],
    kmlwarehouse: [],
    kmlwarehousebygroup: [],
    kmlwarehousechild: [],
    leaflettracks: [],
    legend: [],
    modules: [],
    notetype: [],
    nutrientsaddition: [],
    observationact: [],
    orderforshipment: [],
    organizationgroupcarmodels: [],
    organizationgroupinstruments: [],
    organizationgroupmodules: [],
    organizationinstruments: [],
    organizations: [],
    organizationsgroup: [],
    organizationtype: [],
    outgoingtransfers: [],
    ownershiptype: [],
    pages: [],
    pageviewrecords: [],
    paymentsadditionals: [],
    permissiongroups: [],
    permissionsbyuserrole: [],
    previoussowings: [],
    processedstatuses: [],
    productreservations: [],
    printforms: [],
    provider: [],
    qualitytypes: [],
    qualitytypevaluecodes: [],
    realizations: [],
    reproductions: [],
    reservationtypes: [],
    ripenessgroups: [],
    seedlimitcoordinates: [],
    seedlimitcoordinateschild: [],
    seedlimits: [],
    seedlimitschild: [],
    seedlimitsgroup: [],
    seedmordant: [],
    seedprices: [],
    sensorsettings: [],
    suppliers: [],
    sensortypes: [],
    smells: [],
    soiltypes: [],
    soilstructures: [],
    soilresearches: [],
    sorts: [],
    sowings: [],
    sowingsall: [],
    stopjournals: [],
    stoptypes: [],
    storages: [],
    storagetypes: [],
    suboperations: [],
    transfertypes: [],
    tankcarsensorsetting: [],
    tanksensorsettingvaluetypes: [],
    tanksensorsettingvaluetypesenum: [],
    technologyreciept: [],
    technologyreciepttypes: [],
    terrains: [],
    thirdpartyelevatorgrains: [],
    threatlevel: [],
    transfertoelevators: [],
    transportationroutecategories: [],
    transportationpointtypes: [],
    transportationrate: [],
    transportationjobtypes: [],
    transportationroutes: [],
    unittypes: [],
    userpermissions: [],
    userrole: [],
    users: [],
    volumetypes: [],
    warehouses: [],
    warehouseschild: [],
    warehousetypes: [],
    weed: [],
    weedgrowingphases: [],
    weedtypes: [],
    workconditions: [],
    workdates: [],
    works: [],
    worktypeparameterplanworktypes: [],
    worktypeparameters: [],
    yearconstants: [],
    inventoryanalysiscards: [],
    orderForShipmentAnalysisCards: [],
    ndviaverage: [],
    agrooperations: [],
    providercarrfidtable: [],
    approvedbudget: [],
    grainindicators: [],
    resourcetype: [],
    otherproducts: [],
    chemicalpreparationmanufacturer: [],
    beehazardclasses: [],
    technologyaggregates: [],

    chemistrymovement: [],
    seedlimittmc: [],
    chemistrylimittmc: [],
    maintenancetype: [],
    maintenancecategorytypes: [],
    usersfull: []
  }
}

const state = {
  ...initialState(),
  budgets: [...budgets],
  fields: [],
  fieldsspec: [],
  userorganizations: [],
  responseStatus: {},
};

const getters = {
  getEntity: (state) => (entity) => {
    entity = entity.toLowerCase();
    return deepClone(state[entity])
  },
  getEntityById: (state) => (id, entity, attr) => {
    let _attr = attr || "id"
    entity = entity.toLowerCase();
    return deepClone(findBy(state[entity], _attr, id))
  },
  getEntityByParameter: (state) => (param = {name: null, value: null, entity: null}) => {
    param.entity = param.entity.toLowerCase();
    return findBy(state[param.entity], param.name, param.value)
  },
  getResponseStatus: (state) => (entity) => {
    entity = entity.toLowerCase();
    return deepClone(state.responseStatus[entity])
  },
  getEntityObject: (state) => (entity, key = "id") => {
    entity = entity.toLowerCase()
    let name = key === "id" ? entity : `${entity}${key}`
    if (!state.dict[entity] && state[entity] || key !== "id") {
      let result = {}
      state[entity].map(item => {
        result[item[key]] = item
      })
      state.dict[name] = result;
    }
    return state.dict[name] ? state.dict[name] : {}
  },
};

const mutations = {
  addEntity: (state, payload) => {
    payload.state = payload.state.toLowerCase();
    state[payload.state] = payload.data;
  },
  addNewEntityItem: (state, payload) => {
    payload.state = payload.state.toLowerCase();
    let list = deepClone(state[payload.state])
    list.push(payload.data)
    state[payload.state] = deepClone(list)
    setDictEntity(state, state[payload.state])
  },
  editEntityItem: (state, payload) => {
    payload.state = payload.state.toLowerCase();
    let list = deepClone(state[payload.state])
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === payload.data.id) {
        list[i] = {...payload.data}
      }
    }
    state[payload.state] = deepClone(list)
    setDictEntity(state, payload.state)
  },
  deleteEntityItem: (state, {name, id}) => {
    name = name.toLowerCase();
    state[name] = state[name].filter(a => a.id !== id);
  },

  resetEntity: (state, payload) => {
    const iState = initialState()
    payload.state = payload.state.toLowerCase();
    state[payload.state] = iState[payload.state];
  },
  clearEntities: (state, entities) => {
    const iState = initialState()
    const iStateKeys = Object.keys(iState)
    const keys = entities.length ? entities.filter(key => iStateKeys.includes(key)) : iStateKeys
    keys.forEach(key => {
      state[key] = iState[key]
      delete state.responseStatus[key]
    })
  },
  setResponseStatus: (state, payload) => {
    payload.state = payload.state.toLowerCase();
    state.responseStatus[payload.state] = payload.status;
  }
};

function setDictEntity(state, key) {
  let result = {}
  if (state[key]) {
    state[key].map(item => {
      result[item.id] = item
    })
  }
  state.dict[key] = result;
}

const actions = {
  actionAddEntity: ({commit}, payload) => {
    commit("addEntity", {state: payload.name, data: payload.data});
  },
  actionResetEntity: ({commit}, payload) => {
    commit("resetEntity", {state: payload.name});
  },
  actionClearEntities: ({commit}, payload = []) => {
    commit("clearEntities", payload);
  },
  actionSetResponseStatus: ({commit}, payload) => {
    commit("setResponseStatus", {state: payload.name, status: payload.status});
  },

  actionAddEntityItem: ({commit}, payload) => {
    console.log('actionAddEntityItem', payload)
    commit("addNewEntityItem", {state: payload.name, data: payload.data});
  },
  actionEditEntityItem: ({commit}, payload) => {
    commit("editEntityItem", {state: payload.name, data: payload.data});
  },
  actionDeleteEntityItem: ({commit}, payload) => {
    commit("deleteEntityItem", {name: payload.name, id: payload.id});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    Queue,
  },
}
